import React, { Component } from "react";
import styles from './styles.css'

import Container from '../../../components/Container'
import Title from '../../../components/Title'
import Service from '../../../components/Service'

class Services extends Component {
  constructor(props) {
    super(props)

    this.state = {
      mainServices: [
        {
          title: 'ruby',
          classes: 'is-big is-uppercase is-size-2 is-weight-normal is-font-montserrat',
          typeOut: true
        },
        {
          title: 'js',
          classes: 'is-big is-uppercase is-size-2 is-weight-normal is-font-montserrat',
          typeOut: false
        },
        {
          title: 'react',
          classes: 'is-big is-uppercase is-size-2 is-weight-normal is-font-montserrat',
          typeOut: true
        },
        {
          title: 'php',
          classes: 'is-big is-uppercase is-size-2 is-weight-normal is-font-montserrat',
          typeOut: false
        },
        {
          title: 'mysql',
          classes: 'is-big is-uppercase is-size-2 is-weight-normal is-font-montserrat',
          typeOut: false
        },
        {
          title: 'sass',
          classes: 'is-big is-uppercase is-size-2 is-weight-normal is-font-montserrat',
          typeOut: false
        },
        {
          title: 'rails',
          classes: 'is-big is-uppercase is-size-1 is-weight-bold is-italic is-font-open-sans',
          typeOut: true
        },
        {
          title: 'wordpress',
          classes: 'is-big is-size-1 is-weight-normal is-italic is-font-montserrat',
          typeOut: false
        },
        {
          title: 'tdd',
          classes: 'is-big is-uppercase is-size-1 is-weight-light is-underlined is-font-montserrat',
          typeOut: true
        },
      ],
      otherServices: [
        'Illustrator', 'Linux', 'Server Management', 'AWS', 'MAC', 'WINDOWS', 'ZSH', 'BASH',
        'Laravel', 'Sketch', 'CSS', 'API', 'BEM', 'Webpack', 'jQuery', 'Stimulus', 'Postgres',
        'Node.js', 'Gulp', 'React Native', 'SVG', 'HTML', 'Photoshop', 'Vue.js'
      ]
    }
  }

  serviceList() {
    const list = []

    this.state.mainServices.forEach((service) => {
      list.push(<Service key={service.title} title={service.title} typeOut={service.typeOut} className={service.classes} />)
    })

    list.push(<p key='spacer'>&nbsp;</p>)

    this.state.otherServices.forEach((service) => {
      list.push(<Service key={service} title={service} />)
    })

    return list
  }

  render() {
    return (
      <div>
        <Title direction='right'>Services</Title>
        <Container align='center'>
          {this.serviceList()}
        </Container>
      </div>
    )
  }
}

export default Services



// WEBPACK FOOTER //
// ./src/parts/home/Services/index.js